import { useContext } from 'react';
import type { GuidedTourContextValue } from './GuidedTour.types';
import { GuidedTourContext } from './GuidedTourProvider';

const noop = () => undefined;

const FALLBACK_GUIDED_TOUR_CONTEXT: GuidedTourContextValue = {
  activeStepIndex: 0,
  activeTour: null,
  availableTours: [],
  completeTour: noop,
  dismissTour: noop,
  goToNextStep: noop,
  goToPreviousStep: noop,
  registerTours: () => noop,
  startTour: noop,
  status: 'idle',
};

export const useGuidedTour = () => {
  const context = useContext(GuidedTourContext);

  return context ?? FALLBACK_GUIDED_TOUR_CONTEXT;
};
